import * as React from 'react';
import { Avatar as RadixAvatar, AvatarImage, AvatarFallback } from '@/components/ui/avatar';
import { cn } from '@/lib/utils';
import { User } from 'lucide-react';

const Avatar = React.forwardRef(({ src, alt, className, ...restProps }, ref) => (
  <RadixAvatar
    ref={ref}
    className={cn('avatar', className)}
    {...restProps}
  >
    <AvatarImage
      src={src}
      alt={alt || 'foto do usuario'}
      title={alt || 'foto do usuario'}
    />
    <AvatarFallback title={alt || 'foto do usuario'}>
      <User className="h-4 w-4 text-neutral" />
    </AvatarFallback>
  </RadixAvatar>
));

Avatar.displayName = 'Avatar';

export { Avatar };
